/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

import { postDefaultReceivers } from '../../services/yclickMaster';
import CommunicateForm from '../CommunicateForm/CommunicateForm';
import useToast from '../../hooks/useToast';
import LoaderContext from '../../context/LoaderProvider';

import { stepEnumOfAccordion } from './Constants';
import { RequestErrors, RequestField, RequestTouched, RequestValue } from './CreateServiceProps';

const Communicate = ({
  accordionIndex,
  requestErrors,
  requestField,
  requestTouched,
  requestValue,
  setStep,
  disabledAllFields
}) => {
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const { setNewToast } = useToast();
  const { setLoader } = useContext(LoaderContext);
  const [defaultReceivers, setDefaultReceivers] = useState([]);

  const associatedUsersValue = values?.accordions[accordionIndex]?.associatedUsers;
  const associatedUsersField = `${requestField}.associatedUsers` || 'associatedUsers';
  const isOyM = values?.isOyM;

  const isInvalidWithCopyTo =
    requestErrors?.associatedUsers?.aditionalReceivers &&
    requestTouched?.associatedUsers?.aditionalReceivers
      ? !!requestTouched?.associatedUsers?.aditionalReceivers &&
        !!requestErrors?.associatedUsers?.aditionalReceivers
      : false;

  useEffect(() => {
    const adapterResponse = associatedUsersValue?.receivers?.map((receivers) => ({
      label: receivers.nombre
    }));

    setDefaultReceivers(adapterResponse);
  }, [associatedUsersValue?.receivers?.length]);

  const fetchDefaultReceivers = async () => {
    setLoader(true);
    try {
      const providerIdList = requestValue?.provider?.providers?.map(
        (provider) => provider?.provider?.id
      );
      const isSomeUndefined = providerIdList.some((prov) => prov === undefined);

      if (providerIdList.length && !isSomeUndefined) {
        const response = await postDefaultReceivers(providerIdList);
        const adapterResponse = response.map((receivers) => ({
          label: receivers.nombre
        }));

        setDefaultReceivers(adapterResponse);
        setFieldValue(`${associatedUsersField}.receivers`, response);
      }
    } catch (error) {
      setNewToast(error.message);
    } finally {
      setLoader(false);
    }
  };

  const handleSelectChange = (val) => {
    setFieldValue(`${associatedUsersField}.aditionalReceivers`, val);
    setFieldTouched(`${associatedUsersField}.aditionalReceivers`);
    setStep(stepEnumOfAccordion.associatedUsers);
  };

  useEffect(() => {
    fetchDefaultReceivers();
  }, [requestValue?.provider?.providers]);

  return (
    <CommunicateForm
      defaultReceivers={defaultReceivers}
      isOyM={isOyM}
      selectProps={{
        isDisabled: disabledAllFields,
        businessUnitId: values?.ubication?.uunn?.id,
        errors: requestErrors?.associatedUsers?.aditionalReceivers,
        isInvalid: isInvalidWithCopyTo,
        onChange: handleSelectChange,
        value: associatedUsersValue?.aditionalReceivers
      }}
    />
  );
};

Communicate.propTypes = {
  accordionIndex: PropTypes.number.isRequired,
  disabledAllFields: PropTypes.bool,
  setStep: PropTypes.func.isRequired,
  requestErrors: RequestErrors,
  requestField: RequestField.isRequired,
  requestTouched: RequestTouched.isRequired,
  requestValue: RequestValue.isRequired
};

Communicate.defaultProps = {
  disabledAllFields: false,
  requestErrors: {}
};

export default Communicate;
